import _ from 'underscore';
import JSData from 'js-data';
import { JSDataCacheManager } from './js-data-cache-manager';

export class DataStore extends JSData.DS {
  /**
   * A subclass of JSData.DS integrated with the cache manager. This class
   * delegates all public APIs of {@link JSDataCacheManager}.
   * @param {Object} options -
   * @param {CacheOptions} options.cacheOptions -
   *    The constructor parameters for the cache manager. Refer to
   *    {@link JSDataCacheManager}. The `store` property is not needed. It will
   *    be filled with the the newly created store instance.
   */
  constructor(options = {}) {
    super(_.omit(options, 'cacheOptions'));

    // Initialize the cache manager
    this.cacheManager = new JSDataCacheManager(_.defaults({
      store: this,
    }, options.cacheOptions));

    // Delegate the cache manager methods
    _.each([
      'enableCacheOnAdapter',
      'getResult',
      'setResult',
      'getCacheHint',
      'setCacheHint',
      'invalidate',
    ], (name) => {
      this[name] = (...args) => this.cacheManager[name](...args);
    });
  }
}
